import PlaceRoundedIcon from "@mui/icons-material/PlaceRounded";
import { Box, Stack, Typography } from "@mui/material";
import { CARD_STYLES } from "./ScopeOfWorkTypeOfService";

export const ScopeOfWorkTypeOfPlaces = ({ typeOfPlaces }) => {
  if (!typeOfPlaces) return null;

  return (
    <Box sx={CARD_STYLES.root}>
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <Box sx={CARD_STYLES.iconBox}>
          <PlaceRoundedIcon sx={{ fontSize: 20 }} />
        </Box>

        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography sx={CARD_STYLES.sectionLabel}>Type of place</Typography>

          <Typography
            sx={{
              mt: 0.5,
              fontSize: "1rem",
              fontWeight: 800,
              color: "text.primary",
              lineHeight: 1.25,
            }}
          >
            {typeOfPlaces.name}
          </Typography>

          {typeOfPlaces.description ? (
            <Typography
              sx={{
                mt: 0.75,
                fontSize: "0.875rem",
                color: "text.secondary",
                lineHeight: 1.55,
              }}
            >
              {typeOfPlaces.description}
            </Typography>
          ) : null}
        </Box>
      </Stack>
    </Box>
  );
};
